import moment from 'moment';
import { compose } from 'redux';
import Add from '@material-ui/icons/Add';
import { memo, useCallback, useEffect, useState, useMemo } from 'react';
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Grid, Box, Tabs, Tab, Divider } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { useModal } from 'altus-modal';
import { BasePage } from 'altus-ui-components';

import { requestUpdatestringtesttoolstringitem } from 'features/projects/mobilisation/projectMobilisation.actions';
import {
  MODAL,
  ACTIONS,
} from 'features/projects/mobilisation/projectMobilisation.constants';

import {
  createStringTestReport,
  requestStringReportsForTask,
  requestGetstringtesttoolstringitems,
  requestProjectMobilisationTasks,
  validatestringtesttoolstringitemsSerialNumbers,
} from 'features/projects/mobilisation/projectMobilisation.actions';

import {
  getstringtesttoolstringitemsFromState,
  getProjectMobilisationTasksFromState,
  getStringTestReportsForTaskFromState,
} from 'features/projects/mobilisation/projectMobilisation.selectors';

import {
  getCurrentUserFromState,
  getSummarizedDataStateFromState,
} from 'app/app.selectors';

import { useHeader } from 'app/hooks/useHeader';
import { EMPTY_STRING } from 'app/app.constants';
import { Button } from 'app/components/withTooltip';
import MobilisationTasksMenu from 'features/projects/mobilisation/MobilisationTasksMenu';
import StringTestEventContainer from 'features/projects/mobilisation/StringTestEventContainer';
import StringTestEventModalContainer from 'features/projects/mobilisation/StringTestEventModalContainer';

import { List } from 'immutable';

import {
  getToolstringFromState,
  getToolstringToolsFromState,
  getToolstringSectionsFromState,
  getTaskByIdFromState,
} from 'features/projects/tasks/task/toolstring/toolstring.selectors';

import {
  TOOLSTRING_ACTIONS,
  MODAL as ToolstringModal,
} from 'features/projects/tasks/task/toolstring/toolstring.constants';

import { TASK_ACTIONS } from 'features/projects/tasks/tasks.constants';
import { WORK_ITEM_STATUS } from 'app/app.constants';
import { getToolConnectorsFromState } from 'features/projects/tool/tool.selector';

import CreateAssetHistoryModalContainer from 'features/equipment/assets/components/CreateAssetHistoryModalContainer';

import {
  ASSET_HISTORY_EVENT_TYPES,
  ASSET_HISTORY_EVENT_TYPES_ITEM,
  ASSET_HISTORY_TEST_TYPE,
  ASSET_HISTORY_TEST_TYPES,
  EquipmentType,
} from 'features/equipment/equipment.constants';

import Icon from '@material-ui/icons/Build';

import { NoContentBasePage } from 'altus-ui-components';

import TaskToolstringEditorContent from 'features/projects/tasks/task/toolstring/components/edit/TaskToolstringEditorContent';

import TaskToolstringExportModalContainer from 'features/projects/tasks/task/toolstring/TaskToolstringExportModalContainer';
import GotoBhaModalModalContainer from 'features/projects/tasks/task/toolstring/GotoBhaEditModalContainer';

import {
  receiveTaskToolstring,
  requestGetTaskToolstring,
  requestTaskToolstringSections,
} from 'features/projects/tasks/task/toolstring/toolstring.actions';
import { requestToolConnectors } from '../tool/tool.actions';
import toolstringService from 'services/toolstring.service';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      overflow: 'hidden',
    },
    tabsContainer: {
      overflow: 'hidden',
      height: 'calc(100% - 20px)',
      width: '100vw',
    },
    basePageChildren: {
      paddingTop: theme.spacing(2.25),
    },
    leftMenu: {
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    tab: {
      backgroundColor: 'transparent !important',
    },
    divider: {
      marginBottom: theme.spacing(1.25),
    },
  }),
);
const checkSerialNumbers = (tools) => {
  const isInvalidSerial = (serialNo) =>
    serialNo === EMPTY_STRING || serialNo === null;

  return !tools.some(
    (tool) =>
      (tool.toolAssemblyTools.length > 0 &&
        tool.toolAssemblyTools.some(
          (subTool) =>
            isInvalidSerial(subTool.serialNo) ||
            subTool.attachedTools.some((attachedTool) =>
              isInvalidSerial(attachedTool.serialNo),
            ),
        )) ||
      (tool.attachedTools.length > 0 &&
        tool.attachedTools.some((attachedTool) =>
          isInvalidSerial(attachedTool.serialNo),
        )) ||
      (tool.toolAssemblyTools.length === 0 && isInvalidSerial(tool.serialNo)),
  );
};

const formatCurrentDateTime = () => {
  const currentMoment = moment.utc();
  return currentMoment.format('YYYY-MM-DDTHH:mm:ssZ');
};

const MobilisationContainer = ({
  breadcrumb,
  dataState,
  projectId,
  dispatchGetToolstring,
  dispatchToolstringSections,
  dispatchRequestToolConnectors,
  dispatchUpdatestringtesttoolstringitem,
}) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(null); // StringTestId
  const [selectedTaskExternalId, setSelectedTaskExternalId] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null); // TASK ID, NOT WHOLE OBJECT
  const [serialNumbersDone, setSerialNumbersDone] = useState(false);
  const [selectedToolstringId, setSelectedToolstringId] = useState(null);
  const [selectedStringTestReport, setSelectedStringTestReport] =
    useState(null);
  const hiddenColumns = useMemo(
    () => [
      'yieldValue',
      'botC',
      'topC',
      'supplier',
      'hideAssemblySerialNumber',
      'status',
      'actions',
    ],
    [],
  );
  const hideSerialNo = 'hideSerialNumbers';
  const [isOpen, toggleModal] = useModal(MODAL.ADD_ASSET_HISTORY_BHA);

  const tasks = useSelector(getProjectMobilisationTasksFromState);
  const [isToolstringExportModalOpen, toggleToolstringExportModal] = useModal(
    ToolstringModal.SIMULATION_EXPORT_MODAL_ID,
  );

  const [isRouteBhaEditModalOpen, toggleIsRouteBhaEditModalOpen] = useModal(
    MODAL.ROUTE_BHA_EDITOR,
  );

  const testTypesItems = List([
    ASSET_HISTORY_TEST_TYPES.find(
      (item) => item.id === String(ASSET_HISTORY_TEST_TYPE.STRING_TEST),
    ),
  ]).filter((item) => item);

  const assetHistoryEventTypes = List([
    ASSET_HISTORY_EVENT_TYPES.find(
      (item) => item.id === String(ASSET_HISTORY_EVENT_TYPES_ITEM.TEST),
    ),
  ]).filter((item) => item);

  const openModal = (event) => {
    event?.preventDefault();
    toggleModal();
  };

  const paddingTopPreview = 0;
  const widthSerialColumn = 2;
  const isLastInList = useCallback(
    (allStringTestReports, selectedStringTestReportItem) => {
      const equalValue =
        allStringTestReports.last() === selectedStringTestReportItem;

      if (!equalValue && !allStringTestReports?.size) {
        return serialNumbersDone;
      }

      return equalValue;
    },
    [serialNumbersDone],
  );

  useEffect(() => {
    dispatch(requestProjectMobilisationTasks(projectId));
  }, [dispatch, projectId]);

  useEffect(() => {
    if (selectedToolstringId && selectedTask) {
      dispatch(requestStringReportsForTask(selectedTask, selectedToolstringId));
    }
  }, [selectedToolstringId, dispatch, selectedTask]);

  useEffect(() => {
    if (selectedToolstringId) {
      dispatch(
        requestGetstringtesttoolstringitems(selectedTask, selectedToolstringId),
      );
    }
  }, [dispatch, selectedTask, selectedToolstringId]);

  const user = useSelector(getCurrentUserFromState);
  const stringtesttoolstringitems = useSelector(
    getstringtesttoolstringitemsFromState,
  );

  const stringTestReports = useSelector(getStringTestReportsForTaskFromState);

  useEffect(() => {
    if (tasks.size) {
      setSelectedTask(tasks.first().get('taskId'));
      setSelectedTaskExternalId(tasks.first().get('externalId'));
      setSelectedToolstringId(
        tasks
          .first()
          .toJS()
          .toolStrings.find((t) => t.isPlanned).toolStringId,
      );
    }
  }, [tasks]);

  useEffect(() => {
    if (stringTestReports.size) {
      setActiveTab(stringTestReports.last().get('stringTestId'));
      setSelectedStringTestReport(stringTestReports.last());
    } else {
      setSelectedStringTestReport(undefined);
      setActiveTab(undefined);
    }
  }, [stringTestReports]);

  const handleTaskSelection = (value) => {
    let toolstringid = tasks
      .toJS()
      .find((x) => x.taskId === value.taskId)
      .toolStrings.find((t) => t.isPlanned).toolStringId;
    setSelectedTask(value.taskId);
    setSelectedTaskExternalId(value.externalId);
    setSelectedToolstringId(toolstringid);
    dispatch(requestStringReportsForTask(value.taskId, toolstringid));

  };

  const handleTabs = (event, value) => {
    setActiveTab(value);
    setSelectedStringTestReport(
      stringTestReports.find((report) => report.get('stringTestId') === value),
    );
  };
  const createDraftStringTestReport = useCallback(() => {
    const userId = user.get('id');
    const toolstringId = selectedToolstringId;
    const taskId = selectedTask;
    const timeCreated = formatCurrentDateTime();

    const stringTestReport = {
      result: 0,
      time: timeCreated,
      userId,
      toolstringId,
      taskId,
      testType: 'StringTest',
      isMobilize: true,
    };

    dispatch(
      createStringTestReport(projectId, taskId, stringTestReport, false),
    );
  }, [dispatch, user, selectedToolstringId, selectedTask, projectId]);

  const validatestringtesttoolstringitemsSerials = useCallback(() => {
    const stringtesttoolstringitemsIds = stringtesttoolstringitems
      .filter((item) => item.get('stringTestId') === activeTab)
      .map((item) => item.get('stringTestToolStringItemId'));

    dispatch(
      validatestringtesttoolstringitemsSerialNumbers(
        stringtesttoolstringitemsIds.toJS(),
      ),
    );
  }, [dispatch, stringtesttoolstringitems, activeTab]);

  const disabledSerialNumbers = () => {
    if (
      selectedTaskExternalId === selectedStringTestReport?.get('externalTaskId')
    ) {
      return selectedStringTestReport?.get('result') === 0 ? false : true;
    }

    return false;
  };

  const toolConnectors = useSelector((state) =>
    getToolConnectorsFromState(state),
  );

  const toolstring = useSelector((state) =>
    getToolstringFromState(state, selectedToolstringId),
  );

  const toolstringSections = useSelector((state) =>
    getToolstringSectionsFromState(state, selectedToolstringId),
  );
  const toolstringTools = useSelector((state) =>
    getToolstringToolsFromState(state, selectedToolstringId, activeTab),
  );
  const columns = 1;

  const task = useSelector((state) =>
    getTaskByIdFromState(state, selectedTask),
  );

  useEffect(() => {
    setSerialNumbersDone(checkSerialNumbers(toolstringTools.toJS()));
  }, [toolstringTools, setSerialNumbersDone]);

  const getPlannedToolstring = useCallback(
    () =>
      toolstringService
        .getPlannedToolstring(projectId, selectedTask, true, activeTab)
        .then((toolstring) => {
          setSelectedToolstringId(toolstring?.toolStringId);
          dispatch(receiveTaskToolstring(projectId, selectedTask, toolstring));
          dispatchGetToolstring(
            projectId,
            selectedTask,
            toolstring?.toolStringId,
            true,
            activeTab,
          );

          dispatchToolstringSections(
            projectId,
            selectedTask,
            toolstring?.toolStringId,
            true,
            activeTab,
          );
        }),
    [
      dispatch,
      dispatchGetToolstring,
      dispatchToolstringSections,
      projectId,
      selectedTask,
      activeTab,
    ],
  );

  useEffect(() => {
    if (projectId && selectedTask) {
      getPlannedToolstring();
    }
  }, [getPlannedToolstring, projectId, selectedTask]);

  const updatestringtesttoolstringitem = useCallback(
    (asset) => {
      dispatchUpdatestringtesttoolstringitem(
        selectedTask,
        selectedToolstringId,
        projectId,
        asset,
        activeTab,
      );
    },
    [
      selectedTask,
      selectedToolstringId,
      dispatchUpdatestringtesttoolstringitem,
      projectId,
      activeTab,
    ],
  );

  useEffect(() => {
    dispatchRequestToolConnectors();
  }, [dispatchRequestToolConnectors]);

  useEffect(() => {
    const taskStatus = task?.get('status');
    if (taskStatus && taskStatus >= WORK_ITEM_STATUS.COMPLETED) {
      !hiddenColumns.includes(hideSerialNo) && hiddenColumns.push(hideSerialNo);
    } else {
      hiddenColumns.includes(hideSerialNo) &&
        hiddenColumns.splice(hiddenColumns.indexOf(hideSerialNo), 1);
    }
  }, [hiddenColumns, selectedTask, task]);
  const classes = useStyles();

  useHeader({ subTitle: breadcrumb });

  const [eventModal, toggleEventModal] = useModal(
    MODAL.STRING_TEST_REPORT_EVENT,
  );
  return (
    <BasePage
      dataState={dataState}
      classes={{
        children: classes.basePageChildren,
      }}
    >
      <Grid container item xs wrap="nowrap" className={classes.root}>
        <Grid
          item
          xs={2}
          component={Box}
          className={classes.leftMenu}
          paddingRight={2}
          paddingTop={0.5}
        >
          <MobilisationTasksMenu
            tasks={tasks}
            selectedTask={selectedTask}
            handleTaskSelection={handleTaskSelection}
          />
        </Grid>
        <Grid item container xs={10} component={Box}>
          <Grid item container xs={11} justifyContent="flex-end">
            {isLastInList(stringTestReports, selectedStringTestReport) ? (
              <Button
                color="primary"
                variant="contained"
                disabled={
                  selectedStringTestReport?.get('result') === 0 ||
                  selectedStringTestReport === null ||
                  selectedStringTestReport === undefined
                }
                onClick={() => createDraftStringTestReport()}
                className={classes.divider}
              >
                <Box component={Add} marginRight={0.5} />
                Add new string test
              </Button>
            ) : null}
          </Grid>
          {stringTestReports.size ? (
            <Grid item container xs={11}>
              <Tabs value={activeTab} onChange={handleTabs}>
                {stringTestReports.map((report, index) => (
                  <Tab
                    label={`String Test ${index + 1}`}
                    value={report.get('stringTestId')}
                    className={classes.tab}
                  />
                ))}
              </Tabs>
              <Divider className={classes.divider} />
              {selectedStringTestReport &&
              selectedStringTestReport.get('result') !== 0 ? (
                <StringTestEventContainer
                  projectId={projectId}
                  taskId={selectedTask}
                  selectedStringTestReport={selectedStringTestReport}
                />
              ) : null}
            </Grid>
          ) : null}
          <Grid container item xs={11} justifyContent="flex-end">
            {selectedTask &&
            tasks.size &&
            !selectedStringTestReport?.get('result') ? (
              <Button
                color="primary"
                variant="contained"
                disabled={
                  !serialNumbersDone ||
                  selectedStringTestReport?.get('stringTestReportEventId')
                }
                onClick={() => validatestringtesttoolstringitemsSerials()}
              >
                <Box component={PlaylistPlayIcon} marginRight={0.5} />
                Report string test
              </Button>
            ) : null}
          </Grid>
          <Grid container item xs={12} className={classes.tabsContainer}>
            {selectedTask ? (
              <>
                <CreateAssetHistoryModalContainer
                  toggleModal={openModal}
                  isOpen={isOpen}
                  equipmentType={EquipmentType.BHA}
                  getAssetAfterRefresh={false}
                  assetHistoryEventTypes={assetHistoryEventTypes}
                  testTypesItems={testTypesItems}
                  toolstringId={selectedToolstringId}
                  taskId={selectedTask}
                  defaultEventValue={String(
                    ASSET_HISTORY_EVENT_TYPES_ITEM.TEST,
                  )}
                  defaultTestTypeValue={String(
                    ASSET_HISTORY_TEST_TYPE.STRING_TEST,
                  )}
                  modalTitle="String Verification"
                />
                {!toolstringTools ? (
                  <NoContentBasePage
                    Icon={Icon}
                    header="Tool String"
                    description="No tool string has been planned for this task."
                  />
                ) : (
                  <>
                    <TaskToolstringEditorContent
                      hideDragHandle={true}
                      className={classes.toolstringPreview}
                      taskId={selectedTask}
                      style={{ flexWrap: 'wrap' }}
                      projectId={projectId}
                      toolstring={toolstring}
                      toolstringId={selectedToolstringId}
                      toolConnectors={toolConnectors}
                      toolstringTools={toolstringTools}
                      toolstringSections={toolstringSections}
                      updateItemProperties={updatestringtesttoolstringitem}
                      showHeader={false}
                      hiddenColumns={hiddenColumns}
                      hideBreakPoints={true}
                      height="90%"
                      columns={columns}
                      paddingTopPreview={paddingTopPreview}
                      widthSerialColumn={widthSerialColumn}
                      showBreakPoint={false}
                      showCustomActions={null}
                      disabledSerialNumbers={disabledSerialNumbers()}
                      disableToolStatus={true}
                    />
                    <Divider variant="middle" />
                    <TaskToolstringExportModalContainer
                      taskId={selectedTask}
                      projectId={projectId}
                      toolstringId={selectedToolstringId}
                      open={isToolstringExportModalOpen}
                      toggleModal={toggleToolstringExportModal}
                    />
                    <GotoBhaModalModalContainer
                      taskId={selectedTask}
                      projectId={projectId}
                      toolstringId={selectedToolstringId}
                      toggleModal={toggleIsRouteBhaEditModalOpen}
                      open={isRouteBhaEditModalOpen}
                    />
                  </>
                )}
              </>
            ) : (
              <NoContentBasePage
                Icon={Icon}
                header="Tool String"
                description="No tool string has been planned for this task."
              />
            )}
          </Grid>
        </Grid>
        <StringTestEventModalContainer
          secondaryStringTestReports={stringTestReports.size ? true : false}
          toggleModal={toggleEventModal}
          isOpen={eventModal}
          taskId={selectedTask}
          projectId={projectId}
          selectedToolstringId={selectedToolstringId}
          selectedStringTestReport={selectedStringTestReport}
        />
      </Grid>
    </BasePage>
  );
};

const mapStateToProps = (state) => {
  return {
    dataState: getSummarizedDataStateFromState(
      state,
      TOOLSTRING_ACTIONS.REQUEST_GET_TOOLSTRING_FOR_TASK,
      TOOLSTRING_ACTIONS.REQUEST_TOOLSTRING_SECTIONS,
      TOOLSTRING_ACTIONS.REQUEST_SORT_TOOLSTRING_TOOLS,
      TOOLSTRING_ACTIONS.DOWNLOAD_TOOLSTRING_PDF_REPORT,
      TOOLSTRING_ACTIONS.REQUEST_UPDATE_SERIAL_NUMBERS_FROM_TASK,
      TASK_ACTIONS.GET_ALL_TASKS,
      ACTIONS.CREATE_STRING_TEST_REPORT,
      ACTIONS.REQUEST_STRING_TEST_REPORT_EVENT,
      ACTIONS.REQUEST_PROJECT_MOBILISATION_TASKS,
      ACTIONS.RECEIVE_PROJECT_MOBILISATION_TASKS,
      ACTIONS.REQUEST_STRING_TEST_REPORTS_FOR_TASK,
      ACTIONS.RECEIVE_STRING_TEST_REPORTS_FOR_TASK,
      ACTIONS.RECEIVE_PROJECT_MOBILISATION_TOOLSTRINGS,
    ),
  };
};

const mapDispatchToProps = {
  dispatchGetToolstring: requestGetTaskToolstring,
  dispatchToolstringSections: requestTaskToolstringSections,
  dispatchUpdatestringtesttoolstringitem: requestUpdatestringtesttoolstringitem,
  dispatchRequestToolConnectors: requestToolConnectors,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo,
)(MobilisationContainer);
